import { apiClient } from '../../gateways/api'
import type { FetchStatusConfig } from '../types/FetchStatusConfig'

export { fetchStatusConfig, initialState }

const initialState: FetchStatusConfig = {
  data: {
    processtappen: [],
    processtappenHoofdleiding: [],
  },
}

const fetchStatusConfig = async (): Promise<FetchStatusConfig['data']> => {
  const { data } = await apiClient({
    url: '/rest/statusconfig',
    method: 'GET',
  })
  return data
}
